export const filterOptionsArray = [
  { id: 'today', name: 'Today', initialValueCalc: 0, endValueCalc: 0 },
  { id: '1DaysAgo', name: 'Yesterday', initialValueCalc: -1, endValueCalc: -1 },
  { id: '2DaysAgo', name: '2 days ago', initialValueCalc: -2, endValueCalc: -2 },
  { id: '3DaysAgo', name: '3 days ago', initialValueCalc: -3, endValueCalc: -3 },
  { id: 'Last7Days', name: 'Last 7 days', initialValueCalc: -6, endValueCalc: 0 },
  { id: 'Last14Days', name: 'Last 14 days', initialValueCalc: -13, endValueCalc: 0 },
  { id: 'Last30Days', name: 'Last 30 days', initialValueCalc: -29, endValueCalc: 0 },
  { id: 'Last60Days', name: 'Last 60 days', initialValueCalc: -59, endValueCalc: 0 },
  { id: 'Last90Days', name: 'Last 90 days', initialValueCalc: -89, endValueCalc: 0 },
  { id: 'LastMonth', name: 'Last Month' },
  { id: 'ThisMonth', name: 'This Month' },
  { id: 'FromTheBeginning', name: 'From the beginning' },
];
